<template>
  <ComponentCard title="Cards to swipe" icon="solar:slider-horizontal-linear">
    <BlockField :model-value="attrs.title" placeholder="Title (optional)" :read-only="readOnly" input-class="font-display text-base font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <OptionGroup v-if="!readOnly" label="Show as" :value="attrs.style" :options="STYLE_OPTIONS" @pick="set({ style: $event })" />
    <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
      <div v-for="(item, i) in attrs.items" :key="i" class="flex items-start gap-2 rounded-xl bg-[#1c4848]/[0.03] p-2">
        <img v-if="item.image" :src="item.image" alt="" class="mt-1 h-12 w-12 shrink-0 rounded-full object-cover" draggable="false">
        <div class="min-w-0 flex-1">
          <BlockField :model-value="item.title" placeholder="Title" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="list.patch(i, { title: $event })" />
          <BlockField :model-value="item.text" placeholder="A line or two" :read-only="readOnly" input-class="text-sm text-[#1c4848]/80" @update:model-value="list.patch(i, { text: $event })" />
          <div v-if="!readOnly" class="flex flex-wrap items-center gap-2 px-2">
            <ImagePicker :context="context" :has-image="Boolean(item.image)" compact @picked="list.patch(i, { image: $event })" />
            <RowActions :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
          </div>
        </div>
      </div>
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add({ title: '', text: '', image: '' })">+ Add a card</button>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import OptionGroup from '@/components/writer/views/OptionGroup.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const STYLE_OPTIONS = [{ value: 'cards', label: 'Cards' }, { value: 'pills', label: 'Pills' }];

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
</script>
